import React from 'react';
import { CircularProgress, Grid } from '@material-ui/core';

export default function FullScreenLoadingProgress(props) {
    return (
        < Grid container style={props.style??{ height: '70vh' }} justify="center" alignItems="center">
            <CircularProgress />
        </Grid >);
}
